exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".failure {\n  background-color: #ffeef0; }\n\n.success {\n  background-color: rgba(92, 184, 92, 0.2); }\n\n.started, .received {\n  background-color: rgba(51, 115, 170, 0.2); }\n\n.pending {\n  background-color: rgba(253, 164, 41, 0.2); }\n\n.retry {\n  background-color: rgba(51, 115, 170, 0.2); }\n\n.revoked {\n  background-color: rgba(119, 119, 119, 0.2); }\n", ""]);

// exports
